import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import { PublicSite } from "@/pages/PublicSite";
import { AuthPage } from "@/pages/AuthPage";
import { Onboarding } from "@/pages/Onboarding";
import { Dashboard } from "@/pages/Dashboard";
import { Storefront } from "@/pages/Storefront";
import { Admin } from "@/pages/Admin";
import { PlatformAgreementPage } from "@/pages/PlatformAgreementPage";
import { DomainNotConnected } from "@/pages/DomainNotConnected";
import { isCustomDomainHost } from "@/lib/customDomain";

function PlatformRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PublicSite page="home" />} />
      <Route path="/how-it-works" element={<PublicSite page="how" />} />
      <Route path="/pricing" element={<PublicSite page="pricing" />} />
      <Route path="/features" element={<PublicSite page="features" />} />
      <Route path="/about" element={<PublicSite page="about" />} />
      <Route path="/contact" element={<PublicSite page="contact" />} />
      <Route path="/blog" element={<PublicSite page="notfound" />} />
      <Route path="/terms" element={<PublicSite page="terms" />} />
      <Route path="/privacy" element={<PublicSite page="privacy" />} />
      <Route path="/cookies" element={<PublicSite page="cookies" />} />
      <Route path="/refund" element={<PublicSite page="refund" />} />
      <Route path="/impressum" element={<PublicSite page="impressum" />} />
      <Route path="/dpa" element={<PublicSite page="dpa" />} />
      <Route path="/legal/:docId" element={<PlatformAgreementPage />} />
      <Route path="/signup" element={<AuthPage mode="signup" />} />
      <Route path="/login" element={<AuthPage mode="login" />} />
      <Route path="/forgot-password" element={<AuthPage mode="forgot" />} />
      <Route path="/reset-password" element={<AuthPage mode="reset" />} />
      <Route path="/onboarding/:step" element={<Onboarding />} />
      <Route path="/dashboard" element={<Dashboard section="home" />} />
      <Route path="/dashboard/orders" element={<Dashboard section="orders" />} />
      <Route path="/dashboard/orders/:orderId" element={<Dashboard section="orders" />} />
      <Route path="/dashboard/reservations" element={<Dashboard section="reservations" />} />
      <Route path="/dashboard/reservations/:reservationId" element={<Dashboard section="reservations" />} />
      <Route path="/dashboard/products" element={<Dashboard section="products" />} />
      <Route path="/dashboard/merchandising" element={<Dashboard section="merchandising" />} />
      <Route path="/dashboard/assets" element={<Dashboard section="assets" />} />
      <Route path="/dashboard/theme" element={<Dashboard section="theme" />} />
      <Route path="/dashboard/customers" element={<Dashboard section="customers" />} />
      <Route path="/dashboard/store" element={<Dashboard section="store" />} />
      <Route path="/dashboard/translations" element={<Dashboard section="translations" />} />
      <Route path="/dashboard/testimonials" element={<Dashboard section="testimonials" />} />
      <Route path="/dashboard/support" element={<Dashboard section="support" />} />
      <Route path="/dashboard/settings" element={<Dashboard section="settings" />} />
      <Route path="/admin" element={<Admin section="dashboard" />} />
      <Route path="/admin/dashboard" element={<Admin section="dashboard" />} />
      <Route path="/admin/merchants" element={<Admin section="merchants" />} />
      <Route path="/admin/merchants/:merchantId" element={<Admin section="merchant-detail" />} />
      <Route path="/admin/owners" element={<Admin section="owners" />} />
      <Route path="/admin/payments" element={<Admin section="payments" />} />
      <Route path="/admin/users" element={<Admin section="users" />} />
      <Route path="/admin/analytics" element={<Admin section="analytics" />} />
      <Route path="/admin/audit" element={<Admin section="audit" />} />
      <Route path="/admin/audit/:auditId" element={<Admin section="audit-detail" />} />
      <Route path="/admin/logs" element={<Admin section="logs" />} />
      <Route path="/admin/logs/:logId" element={<Admin section="log-detail" />} />
      <Route path="/preview" element={<Storefront />} />
      <Route path="/:slug" element={<Storefront />} />
      <Route path="/:slug/menu" element={<Storefront view="menu" />} />
      <Route path="/:slug/legal/:docType" element={<Storefront view="legal" />} />
      <Route path="/:slug/checkout" element={<Storefront view="checkout" />} />
      <Route path="/:slug/order/:orderId" element={<Storefront view="status" />} />
      <Route path="*" element={<PublicSite page="notfound" />} />
    </Routes>
  );
}

function CustomDomainRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Storefront />} />
      <Route path="/menu" element={<Storefront view="menu" />} />
      <Route path="/legal/:docType" element={<Storefront view="legal" />} />
      <Route path="/checkout" element={<Storefront view="checkout" />} />
      <Route path="/order/:orderId" element={<Storefront view="status" />} />
      <Route path="*" element={<DomainNotConnected />} />
    </Routes>
  );
}

function App() {
  const customDomain = isCustomDomainHost();
  return (
    <AppProvider>
      <BrowserRouter>
        {customDomain ? <CustomDomainRoutes /> : <PlatformRoutes />}
      </BrowserRouter>
      <Toaster position="top-right" />
    </AppProvider>
  );
}

export default App;
